import EnhancedContactForm from '@components/enhanced-form';
import FormRealtorCards from '@components/enhanced-form/realtor-cards';
import BrokerReciprocityCard from '@components/broker-reciprocity-card';
import { useListingContext } from '../../context';

const PropertySidebar = ({ setRequestATourModalIsOpen }) => {
  const {
    hasTour,
    hasPrimaryAndSecondaryAgent,
    informationRequestDefaultComments,
    listingId: id,
    displayAgents,
    userInfo
  } = useListingContext();

  return (
    <>
      {displayAgents[0] || !!userInfo.agent ? (
        <EnhancedContactForm
          realtors={displayAgents}
          defaultCommentValue={informationRequestDefaultComments}
          hasTour={hasTour}
          hasPrimaryAndSecondaryAgent={hasPrimaryAndSecondaryAgent}
          listingId={id}
          agentIds={displayAgents?.map((agent) => agent.agentId) || []}
          sticky={true}
          setModalIsOpen={setRequestATourModalIsOpen}
          requestType="Listing"
          shouldAllowLeadsPlusAgent
        >
          <FormRealtorCards
            hasTour={hasTour}
            hasPrimaryAndSecondaryAgent={hasPrimaryAndSecondaryAgent}
            setModalIsOpen={setRequestATourModalIsOpen}
            realtors={displayAgents}
            onListingPage={true}
          />
        </EnhancedContactForm>
      ) : (
        <BrokerReciprocityCard
          hasTour={hasTour}
          listingId={id}
          defaultCommentValue={informationRequestDefaultComments}
          sticky={true}
          setModalIsOpen={setRequestATourModalIsOpen}
        />
      )}
    </>
  );
};

export default PropertySidebar;
